import BackHeader from "@components/header/BackHeader";
import { FormProvider, useForm } from "react-hook-form";
import AddressPost from "./components/AddressPost";
import OrderMain from "./components/OrderMain";
import useUserInfoStore from "@store/useUserInfoStore";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import useDirectPurchaseStore from "@store/useDirectPurchaseStore";

export default function Order() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  // const { clearLocalStorage } = useDirectPurchaseStore();

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      name: "",
      country: "",
      postcode: "",
      address: "",
      address_detail: "",
      account_number: "",
    },
  });

  const handleBackEvent = () => {
    if (step > 0) {
      setStep(step - 1);
    } else {
      navigate(-1);
    }
  };

  const tabList = [
    { component: <OrderMain setStep={setStep} handleBack={handleBackEvent} /> },
    { component: <AddressPost setStep={setStep} /> },
  ];

  const titles = ["구매하기", "배송지"];

  return (
    <>
      <FormProvider {...methods}>
        {step !== 2 && (
          <BackHeader title={titles[step]} onClick={handleBackEvent} />
        )}

        <Container>{tabList[step].component}</Container>
      </FormProvider>
    </>
  );
}

const Container = styled.div(() => ({}));
